import React, { FunctionComponent, ReactNode } from 'react'
import { KIND, MARGIN } from './constants'
import { Text } from '../Typography'
import clsx from 'clsx'
import styles from './style.module.scss'
import { useThemeClass } from '../Theme'

type KindType = typeof KIND
type KindKeys = keyof KindType
export type DividerKind = KindType[KindKeys]

type MarginType = typeof MARGIN
type MarginKeys = keyof MarginType
export type DividerMargin = MarginType[MarginKeys]

interface MarginConfig {
  top: DividerMargin
  bottom: DividerMargin
}

export interface DividerProps {
  kind?: DividerKind
  testNameSpace?: string
  margin?: DividerMargin | MarginConfig
  className?: string
  children?: ReactNode
}

export type DividerComponent = FunctionComponent<DividerProps>

export const Divider: DividerComponent = ({ kind = KIND.SOLID, testNameSpace = '', margin = MARGIN.DEFAULT, className, children, ...otherProps }) => {
  const hasChildren = typeof children !== 'undefined'
  const topMargin = typeof margin === 'object' && 'top' in margin ? margin.top : margin
  const bottomMargin = typeof margin === 'object' && 'bottom' in margin ? margin.bottom : margin
  const themeClass = useThemeClass()

  const classes = clsx(
    hasChildren && styles.hasChildren,
    styles[`kind${kind}`],
    styles[`marginTop${topMargin}`],
    styles[`marginBottom${bottomMargin}`],
    className,
    styles[themeClass]
  )

  const optionalAttributes = {
    ...(testNameSpace.length > 0 && { 'data-testid': `${testNameSpace}-divider` }),
  }

  return (
    <div className={classes} {...optionalAttributes} {...otherProps}>
      <hr />
      {hasChildren && <Text>{children}</Text>}
    </div>
  )
}
